import React from "react";
import pdImage from '../../assets/images/personality.jpg';

const PersonalityDevlopmentMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src={pdImage} alt="Personality Development" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Transform Yourself with Sunrising Cinevision Academy's Personality Development Course</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy offers a comprehensive Personality Development course designed to help individuals enhance their confidence, communication, and interpersonal skills. Our program focuses on building a positive self-image, improving body language, and developing leadership qualities. Guided by experienced trainers, you will gain the tools needed to excel in both personal and professional spheres.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Effective communication and public speaking skills</li>
              <li>Confidence building and positive self-image</li>
              <li>Body language and presentation skills</li>
              <li>Leadership and teamwork abilities</li>
              <li>Time management and goal setting</li>
              <li>Emotional intelligence and stress management</li>
              <li>Interview and group discussion techniques</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Foundational Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to Personality Development</li>
              <li>Self-Awareness & Self-Esteem</li>
              <li>Effective Communication Skills</li>
              <li>Body Language Basics</li>
              <li>Building Confidence</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Intermediate Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Public Speaking & Presentation Skills</li>
              <li>Time Management & Goal Setting</li>
              <li>Interpersonal Skills & Teamwork</li>
              <li>Emotional Intelligence</li>
              <li>Stress & Anger Management</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Advanced Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Leadership Skills</li>
              <li>Conflict Resolution</li>
              <li>Decision Making & Problem Solving</li>
              <li>Advanced Communication Techniques</li>
              <li>Professional Etiquette</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Specialized Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Interview Preparation</li>
              <li>Group Discussion Skills</li>
              <li>Personal Branding</li>
              <li>Networking Skills</li>
              <li>Work-Life Balance</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Lead Trainers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Certified Soft Skills Trainers</li>
                <li>Corporate Communication Experts</li>
                <li>Motivational Speakers</li>
                <li>Behavioral Coaches</li>
                <li>HR Professionals</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Speakers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Industry Leaders</li>
                <li>Entrepreneurs</li>
                <li>Renowned Psychologists</li>
                <li>Public Speaking Champions</li>
                <li>Successful Alumni</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Mentorship & Support:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>One-on-one Mentoring</li>
                <li>Career Guidance Sessions</li>
                <li>Mock Interviews</li>
                <li>Resume Building Workshops</li>
                <li>Continuous Feedback</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Leading Corporates & MNCs</li>
              <li>HR Consultancy Firms</li>
              <li>Training & Development Organizations</li>
              <li>Educational Institutions</li>
              <li>Professional Networks</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with alumni in diverse industries</li>
              <li>Participate in mentorship programs</li>
              <li>Access job placement and internship opportunities</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Personality Development</li>
              <li>Advanced Certificate in Soft Skills</li>
              <li>Leadership & Communication Certification</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Women Empowerment Scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Short-term Certificate – 2 months</li>
              <li>Comprehensive Course – 4 months</li>
              <li>Advanced Program – 6 months</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Communicate confidently and effectively in any setting</li>
              <li>Develop a positive attitude and strong self-image</li>
              <li>Enhance leadership, teamwork, and interpersonal skills</li>
              <li>Master public speaking, presentation, and interview skills</li>
              <li>Manage stress, emotions, and time efficiently</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Begin Your Transformation Today!</h3>
          <p className="mb-6 text-gray-700">Enroll in the Personality Development course at Sunrising Cinevision Academy and unlock your true potential for personal and professional success.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default PersonalityDevlopmentMain;
